import { render, staticRenderFns } from "./EnvelopeFace.vue?vue&type=template&id=3cb79b5c&"
import script from "./EnvelopeFace.vue?vue&type=script&lang=js&"
export * from "./EnvelopeFace.vue?vue&type=script&lang=js&"
import style0 from "./EnvelopeFace.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VLayout})
